// export default IncidentRequest;
import React, { useState } from "react";
import BackButton from "components/BackButton";
import DoubtfulList from "./DoubtfulList";
import DoubtfulDetail from "./DoubtfulDetail";

type Props = {
  crimeReferenceNumber?: string;
  incidentRegistrationNumber?: string;
};

const DoubtfulTab: React.FC<Props> = ({
  crimeReferenceNumber,
  incidentRegistrationNumber,
}) => {
  const [pageType, setPageType] = useState<"list" | "detail">("list");
  const [selectedId, setSelectedId] = useState<string | number>("");

  return (
    <div>
      {pageType === "list" ? (
        <DoubtfulList
          crimeReferenceNumber={crimeReferenceNumber}
          incidentRegistrationNumber={incidentRegistrationNumber}
          setSelectedId={setSelectedId}
          setPageType={setPageType}
        />
      ) : (
        <div>
          <BackButton onClick={() => setPageType("list")} />
          <DoubtfulDetail selectedId={selectedId} />
        </div>
      )}
    </div>
  );
};

export default DoubtfulTab;
